import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateAssetIdentification } from '../../../../state';

const ManufacturerEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentAsset } = useAppSelector(state => state.asset);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateAssetIdentification({ manufacturer: event.target.value }));
  };

  return (
    <TextField
      label="Manufacturer"
      size="small"
      fullWidth
      value={currentAsset?.manufacturer || ''}
      onChange={handleChange}
    />
  );
};

export default ManufacturerEdit;
